import React from "react";
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import ExpandingBox from "components/ExpandingBox";

import {openEmail, openURL, openPhone} from "state/app/actions";
import Gate from "components/Gate";

import "./SchoolInfo.css";

class SchoolInfo extends React.Component {
  
  static propTypes = {
    product: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    emailAddress: PropTypes.string.isRequired,
    websiteURL: PropTypes.string.isRequired,
    logo: PropTypes.element.isRequired
  }
  
  openSchoolPhoneNumber = (clickEvent) => {
    clickEvent.stopPropagation();
    this.props.openPhone( this.props.phoneNumber );
  }
  openSchoolEmail = (clickEvent) => {
    clickEvent.stopPropagation();
    this.props.openEmail( this.props.emailAddress );
  }
  openSchoolWebsite = (clickEvent) => {
    
    clickEvent.stopPropagation();
    
    const url = this.props.websiteURL;
    // if the website doesnt start with a protocol
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      this.props.openURL( `http://${url}` );
    // Otherwise, looks like a link - open it.
    } else {
      this.props.openURL(url);
    }

    this.props.openURL( url );

  }

  render() {
    const { product, name, phoneNumber, emailAddress, websiteURL, logo } = this.props;

    const hasPhone = phoneNumber !== "";
    const hasEmail = emailAddress !== "";
    const hasWebsite = websiteURL !== "";

    const placeholder = <div className="school-info__item school-info__item--no-content">This school hasn&apos;t provided any additional information.</div>;
    return (
      <div className={`school-info school-info--${product}`}>
        <ExpandingBox cssModifier={`${product}-school-info`}>
          <ExpandingBox.Header toggleOnClick={true}>
            <div className="school-info__header">
              { logo }
              <div className="school-info__name">{name}</div>
            </div>
          </ExpandingBox.Header>
          <ExpandingBox.Body toggleOnClick={false}>
              <hr />
              <Gate isOpen={hasPhone || hasEmail || hasWebsite} placeholder={placeholder}>
                {hasPhone ? <div className="school-info__item school-info__item--phone"><span className="hyperlink" onClick={this.openSchoolPhoneNumber}>{phoneNumber}</span></div> : null}
                {hasEmail ? <div className="school-info__item school-info__item--email"><span className="hyperlink" onClick={this.openSchoolEmail}>{emailAddress}</span></div> : null}
                {hasWebsite ? <div className="school-info__item school-info__item--website"><span className="hyperlink" onClick={this.openSchoolWebsite}>{websiteURL}</span></div> : null}
              </Gate>
          </ExpandingBox.Body>
        </ExpandingBox>
      </div>
    )
  }
}

export default connect(
  undefined,
  { openURL, openEmail, openPhone }
)(SchoolInfo);



// WEBPACK FOOTER //
// ./src/components/app/info/SchoolInfo.js